module.exports = __webpack_public_path__ + "img/airev-logo-white.ae734230.svg";